import { SmTableColumnStatus } from "./sm-table-column-status.model";

export class SmTableStatus {
    columnStatus: SmTableColumnStatus[] = [];
    // Die Spaltenreihenfolge wird nur übernommen, wenn der Benutzer Spalten selbst verschoben hat
    columnOrderCustomized = false;
}
